import React from 'react';
import { CtaButton } from './CtaButton';
import { FieldDiamond } from './FieldDiamond';
import { PackShot } from './PackShot';
import { images } from '../data/images';
const chips = ['6 Volumes', '5 Bonuses', '300 Pages', '43 Ready-to-Run Practices', 'A full season, planned'];
const levels = ['6U–8U', '10U–12U', 'HS & Rec'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it and coach from it'];
export function Hero() {
  return <section className="wood-bench relative w-full overflow-hidden border-b-4 border-gold" data-id="element-137" data-mp="xanoxzt57hfd">
      {/* Diamante de tiza, motivo de pizarra de coach */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-138" data-mp="s9q8psrp0xgi">
        <FieldDiamond className="absolute -left-16 top-28 h-[300px] w-[300px] text-ice/[0.06] sm:h-[360px] sm:w-[360px]" data-id="element-139" data-mp="nb6mrsd3nlo5" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-5 pt-6 pb-16 sm:pt-10 sm:pb-20" data-id="element-140" data-mp="3czfk1vt6u14g">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-141" data-mp="3814cjrqd82pe">
          <div data-id="element-142" data-mp="3j9247l4e1kty">
            <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-143" data-mp="3j6fwnlhhz5bq">
              The 4-Block Practice System for softball coaches
            </p>
            <h1 className="mt-3 font-display font-bold uppercase text-white text-5xl leading-[.95] tracking-tight sm:text-6xl md:text-7xl" data-id="element-144" data-mp="399jmlbbyab52">
              Your next softball practice is{' '}
              <span className="text-gold" data-id="element-145" data-mp="30gzw4y5tbcvb">already planned.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-146" data-mp="3599jc6fjlytw">
              Softball Season-Ready is a six-volume coaching system: a full
              season of ready-to-run practices &mdash; warm-ups, drills, game
              situations and printable worksheets, for every age and level.
              Not a pile of drills off the internet: the practice itself,
              built in 4 blocks, ready to run.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-147" data-mp="2ljz2uq7z39uq">
              {chips.map(chip => <li key={chip} className="rounded-md border border-ice/25 bg-ice/[0.06] px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ice" data-id="element-148" data-mp="s3mbny4btqw9">
                  {chip}
                </li>)}
            </ul>
          </div>

          {images.hero ? <img src={images.hero} alt="The six Softball Season-Ready volumes and five bonuses" width={2048} height={1360} className="w-full h-auto rounded-2xl shadow-card" data-id="element-149" data-mp="1b0vx1kt7peg5" /> : <PackShot data-id="element-150" data-mp="110wp9q4m9s4c" />}
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-151" data-mp="x1nwanhehy9u">
          <div className="w-full max-w-md" data-id="element-152" data-mp="x37a87fl3x8g">
            <CtaButton data-id="element-153" data-mp="3lt76qudfzxvu">Get Softball Season-Ready</CtaButton>
          </div>

          <div className="mt-5 flex flex-col items-center gap-2 sm:flex-row sm:gap-3" data-id="element-154" data-mp="3hrd9kw2ghc0f">
            <p className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-155" data-mp="3htpzbveggqo1">
              Every practice in three levels
            </p>
            <ul className="flex flex-wrap justify-center gap-2" data-id="element-156" data-mp="21bxx31tbem9r">
              {levels.map(level => <li key={level} className="rounded-full border border-gold/50 px-3 py-1 text-xs font-bold text-gold" data-id="element-157" data-mp="2697o2lwcr5zp">
                  {level}
                </li>)}
            </ul>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-158" data-mp="2kydtwspp3ugk">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-159" data-mp="2p10fwczoql5u">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-160" data-mp="2tztu67msqg72" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}